import script from "./Trades.vue?vue&type=script&setup=true&lang=js"
export * from "./Trades.vue?vue&type=script&setup=true&lang=js"

import "./Trades.vue?vue&type=style&index=0&id=31f9ecde&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f9ecde"]])

export default __exports__